import { Content, Footer, Header, RouterContext, TripleAction } from '../../libs/gs-component-right-rail';
import { Field } from '@xo-union/tk-component-fields';
import { Body2 } from '@xo-union/tk-ui-typography';
import React, { ChangeEvent, useContext, useState } from 'react';

import { usePasswordMutation, Wws_WeddingWebsite } from '../../generated/graphql';
import styles from './editPassword.scss';
import CVAlert from '../CVAlert';
import Honeybadger from 'honeybadger-js';
import { useClient } from '../../apollo/ApolloClientsProvider';
import { DataProxy } from 'apollo-cache';
import { WeddingWebsiteQuery, WeddingWebsiteQueryDocument } from '../../generated/graphql';

interface Props {
  params: {
    pin?: string;
  };
}

export const updatePasswordSuccessCallback = (cache: DataProxy, passwordData?: Partial<Wws_WeddingWebsite>) => {
  const { weddingWebsite, ...rest } = cache.readQuery<WeddingWebsiteQuery>({ query: WeddingWebsiteQueryDocument })!;
  const updatedWeddingWebsite = { ...weddingWebsite, ...passwordData };
  cache.writeQuery({
    query: WeddingWebsiteQueryDocument,
    data: { weddingWebsite: updatedWeddingWebsite, ...rest },
  });
};

export const EditPassword: React.FC<Props> = ({ params: { pin } }) => {
  const { goBack } = useContext(RouterContext);
  const client = useClient();
  const [updatePassword, { loading }] = usePasswordMutation();
  const [value, setValue] = useState(pin || '');
  const [erroring, setErroring] = useState(false);

  const onChange = ({ target }: ChangeEvent<HTMLInputElement>): void => setValue(target.value);

  const onSave = async (): Promise<void> => {
    try {
      const response = await updatePassword({
        variables: {
          attributes: {
            pin: value,
            pinProtect: true,
          },
        },
      });

      updatePasswordSuccessCallback(client.cache, response.data?.updateWeddingWebsite);

      goBack();
    } catch (error) {
      Honeybadger.notify(error, {
        message: 'Error saving password',
        context: {
          error,
        },
      });
      setErroring(true);
    }
  };

  return (
    <>
      <Header leftButtonText="Back" leftButtonOnClick={goBack}>
        Set a password
      </Header>
      <Content>
        <CVAlert erroring={erroring} onTimeout={() => setErroring(false)} />
        <Body2 className={styles.text}>
          Know who's in on your wedding plans by adding a password to your site. Make sure it's easy for guests to
          remember (and for you to share!).
        </Body2>
        <Field
          name="password"
          label="Guest Password"
          value={value}
          onChange={onChange}
          data-testid="edit-guest-password-field"
        />
      </Content>
      <Footer>
        <TripleAction primaryDisabled={loading} primaryOnClick={onSave} primaryText="Save changes" />
      </Footer>
    </>
  );
};
